import script from "./ReplacementPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ReplacementPicker.vue?vue&type=script&setup=true&lang=js"

import "./ReplacementPicker.vue?vue&type=style&index=0&id=a6f4eecc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6f4eecc"]])

export default __exports__